import { EMPTY_GUID } from './CompanyCommissionRate';

export interface CompanyRetentionRateDto {
  id: string;
  companyId: string;
  parentAgency: string;
  retentionArrayType?: string;
  state: string;
  lineOfBusiness: string;
  policyType: string;
  percentage: number | null;
  dollar: number | null;
  APlusCarrierToRate: string[];
  // Only used by the Cancellation Request.
  cancellationReason?: string[];
}

export type CreateCompanyRetentionRateDto = Omit<CompanyRetentionRateDto, 'id' | 'companyId' | 'retentionArrayType'> & {
  retentionArrayType: string;
};

export type UpdateCompanyRetentionRateDto = Omit<CompanyRetentionRateDto, 'companyId' | 'retentionArrayType'> & {
  retentionArrayType: string;
};

export const createEmptyRetentionRate = (companyId: string, parentAgency: string): CompanyRetentionRateDto => ({
  id: EMPTY_GUID,
  companyId,
  parentAgency,
  state: '',
  lineOfBusiness: '',
  policyType: '',
  percentage: null,
  dollar: null,
  APlusCarrierToRate: [],
  cancellationReason: []
});